import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function MyOneBookingModal({ cancelModal, selectedBooking }) {
  const [booking, setBooking] = useState();
  const { user } = useAuthContext();
  const [isLoading, setIsLoading] = useState(true);

// Styled

  useEffect(() => {
    fetchData();
  }, [user]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const bookingResponse = await axios.get(
        `${ApiConnectionString}/api/booking/${selectedBooking.id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (bookingResponse.status == 200) {
        setBooking(bookingResponse.data);
      }
    } catch {
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = async () => {
    setIsLoading(true);
    const updatebooking = {
      id: selectedBooking.id,
    };
    const updateBookingResponse = await axios.put(
      `${ApiConnectionString}/api/booking`,
      updatebooking,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );
    if (updateBookingResponse.status == 200) {
      setIsLoading(false);
      setBooking((prevBooking) => ({
        ...prevBooking,
        cancelPending: true,
      }));
    } else {
      setIsLoading(false);
    }
  };

  const handleReBook = async () => {
    setIsLoading(true);
    const updatebooking = {
      id: selectedBooking.id,
    };
    const updateBookingResponse = await axios.put(
      `${ApiConnectionString}/api/booking`,
      updatebooking,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );
    if (updateBookingResponse.status == 200) {
      setIsLoading(false);
      setBooking((prevBooking) => ({
        ...prevBooking,
        cancelPending: false,
      }));
    } else {
      setIsLoading(false);
    }
  };

  return (
    <div className="send-modal-overlay">
      {!isLoading ? (
        <div className="send-modal">
          <div className="blueBanner">
            <p className="fw-bold m-2 p-2 fontSize20">Booking</p>
          </div>
          <button
            type="button"
            className="close-button"
            onClick={cancelModal}
            aria-label="Close"
          >
            &times;
          </button>

          <div className="d-flex">
            <span className="red-text">Profile</span>
            <p className="mx-3">
              {selectedBooking.viewBookingProfile.username}
            </p>
          </div>
          <div className="d-flex">
            <span className="red-text">Date</span>
            <p className="mx-3">
            {booking.date.substring(0, 10)}
            </p>
          </div>
          <div className="d-flex">
            <span className="red-text">Club</span>
            <p className="mx-3">
            {booking.viewClubs.name}
            </p>
          </div>
          <div className="d-flex">
            <span className="red-text">Event</span>
            <p className="mx-3">
            {selectedBooking.viewEvent.name}
            </p>
          </div>
          <div className="d-flex">
            <span className="red-text">Event</span>
            <p className="mx-3">
            {selectedBooking.viewEvent.name}
            </p>
          </div>
          <div className="d-flex">
            <span className="red-text">Day</span>
            <p className="mx-3">
            {selectedBooking.viewEvent.day}
            </p>
          </div>
          <div className="d-flex">
            <span className="red-text">Time</span>
            <p className="mx-3">
            {selectedBooking.viewEvent.timeIn} -{" "}
            {selectedBooking.viewEvent.timeOut}
            </p>
          </div>

         
        
         
   
          {!booking.cancelPending ? (
            <button className="delete-button" onClick={handleCancel}>
              Request Cancel
            </button>
          ) : (
            <button className="saveChanges-button" onClick={handleReBook}>
            Re-Book
            </button>
          )}
          {booking.cancelPending && (
            <p className="text-danger">Cancel pending</p>
          )}
          <div className="send-modal-footer">
            <button
              onClick={cancelModal}
              className="pointer cancelButton fw-bold mx-2 px-3"
            >
              Close
            </button>
          </div>
        </div>
      ) : (
        <div div className="send-modal">
          <LoadingSpinner />
        </div>
      )}
    </div>
  );
}
